/* eslint-disable */
import { Metrics, Colors, Fonts } from '../../Themes'
import { StyleSheet } from 'react-native'

export default StyleSheet.create({
    separator: {
        borderBottomWidth: 1,
        borderBottomColor: Fonts.style.color.separator,
      }
  })
